"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var state_1 = __importDefault(require("./state"));

var path = __importStar(require("path"));

var p_limit_1 = __importDefault(require("p-limit"));

var volume_1 = require("memfs/lib/volume");

var console_1 = __importDefault(require("./console"));

var container_1 = require("./container");

var proxy_fs_1 = __importDefault(require("./fs/proxy-fs"));

var ContainerFactoryOptions = function () {
  function ContainerFactoryOptions() {
    this.image = '';
  }

  return ContainerFactoryOptions;
}();

exports.ContainerFactoryOptions = ContainerFactoryOptions;
;

var Capsule = function () {
  function Capsule(container, fs, console, state, config) {
    if (config === void 0) {
      config = {};
    }

    this.container = container;
    this.fs = fs;
    this.console = console;
    this.state = state;
    this.config = config;
  }

  Object.defineProperty(Capsule.prototype, "id", {
    get: function get() {
      return '';
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Capsule.prototype, "containerId", {
    get: function get() {
      return this.container.id;
    },
    enumerable: true,
    configurable: true
  });

  Capsule.prototype.start = function () {
    return this.container.start();
  };

  Capsule.prototype.serialize = function () {
    return JSON.stringify(Object.assign({
      id: this.containerId
    }, this.config));
  };

  Capsule.prototype.log = function () {
    return this.container.log();
  };

  Capsule.prototype.on = function (event, fn) {
    this.container.on(event, fn);
  };

  Capsule.prototype.updateFs = function (fs) {
    return __awaiter(this, void 0, void 0, function () {
      var limit, queueWrite;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            limit = p_limit_1.default(1);
            queueWrite = Object.keys(fs).map(function (filePath) {
              return __awaiter(_this, void 0, void 0, function () {
                var _this = this;

                return __generator(this, function (_a) {
                  return [2, limit(function () {
                    return __awaiter(_this, void 0, void 0, function () {
                      return __generator(this, function (_a) {
                        switch (_a.label) {
                          case 0:
                            return [4, this.fs.mkdir(path.dirname(filePath), {
                              recursive: true
                            })];

                          case 1:
                            _a.sent();

                            return [4, this.fs.writeFile(filePath, fs[filePath])];

                          case 2:
                            _a.sent();

                            return [2];
                        }
                      });
                    });
                  })];
                });
              });
            });
            return [4, Promise.all(queueWrite)];

          case 1:
            _a.sent();

            return [2];
        }
      });
    });
  };

  Capsule.prototype.pause = function () {
    return this.container.pause();
  };

  Capsule.prototype.resume = function () {
    return this.container.resume();
  };

  Capsule.prototype.stop = function () {
    return this.container.stop();
  };

  Capsule.prototype.status = function () {
    return this.container.inspect();
  };

  Capsule.prototype.exec = function (execOpions) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2, this.container.exec(execOpions)];
      });
    });
  };

  Capsule.prototype.download = function (options) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2, this.container.download(options)];
      });
    });
  };

  Capsule.prototype.destroy = function () {
    return this.container.stop();
  };

  Capsule.buildFs = function (memFs, containerFs) {
    var fs = proxy_fs_1.default.createProxyFs(memFs, containerFs);
    return fs;
  };

  Capsule.create = function (containerFactory, volume, config, initialState, console) {
    if (volume === void 0) {
      volume = new volume_1.Volume();
    }

    if (config === void 0) {
      config = {};
    }

    if (initialState === void 0) {
      initialState = new state_1.default();
    }

    if (console === void 0) {
      console = new console_1.default();
    }

    return __awaiter(this, void 0, void 0, function () {
      var container, fs;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, containerFactory.createContainer(config)];

          case 1:
            container = _a.sent();
            return [4, container_1.ContainerFS.fromJSON(container, {})];

          case 2:
            fs = _a.sent();
            return [2, new this(container, this.buildFs(volume, fs), console, initialState, config)];
        }
      });
    });
  };

  Capsule.obtain = function (containerFactory, raw) {
    return __awaiter(this, void 0, void 0, function () {
      var object, container, fs;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            object = JSON.parse(raw);
            return [4, containerFactory.obtain(object)];

          case 1:
            container = _a.sent();
            return [4, container_1.ContainerFS.fromJSON(container, {})];

          case 2:
            fs = _a.sent();
            return [2, new this(container, this.buildFs(new volume_1.Volume(), fs), new console_1.default(), new state_1.default())];
        }
      });
    });
  };

  Capsule.image = 'ubuntu';
  return Capsule;
}();

exports.default = Capsule;